import React, {useState} from 'react';
import OurSolutions from '../../../react4xp/components/OurSolutions'


function OurSolutionsPart({componentPath, title, intro, solutions}) {
	const animatedIconPaths = solutions?.map(solution => ({
		name: solution.name,
		path: solution.jsonUrl,
		href: solution.href
	}))
	return <OurSolutions componentPath={componentPath} title={title} text={intro} animatedIconPaths={animatedIconPaths} />
}

export default (props) => <OurSolutionsPart {...props} />
